import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import uniqueId from 'react-html-id';
import './CheckBoxGroup.scss';
import { TEXT_FIELD_IS_REQUIRED } from '../../../utils/messages';
import { CONTEXT_PROVIDERS, CPI_VALUES, DAILY_BUDGET_VALUES, TEXT_FIELD_STATUS } from '../../../utils/constants';
import CurrencyFieldPlatforms from '../CurrencyFieldPlatforms/CurrencyFieldPlatforms';

class CheckBoxGroup extends Component {
  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.node.isRequired).isRequired,
    values: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    value: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    name: PropTypes.string.isRequired,
    changeHandler: PropTypes.func.isRequired,
    isRequired: PropTypes.bool,
    registerField: PropTypes.func.isRequired,
    header: PropTypes.string,
    status: PropTypes.string.isRequired,
    errorText: PropTypes.string.isRequired,
    nonClickable: PropTypes.shape({}),
    disabled: PropTypes.arrayOf(PropTypes.string),
    cpiCurrentPlatform: PropTypes.func,
    cpiFieldState: PropTypes.arrayOf({}),
    dailyBudgetState: PropTypes.arrayOf({}),
    isAdmin: PropTypes.bool,
    cpiFieldName: PropTypes.string,
    dailyBudgetName: PropTypes.string,
  };
  static defaultProps = {
    isRequired: false,
    header: '',
    disabled: [],
    nonClickable: {},
    cpiCurrentPlatform: null,
    cpiFieldState: [],
    dailyBudgetState: [],
    isAdmin: true,
    cpiFieldName: 'default',
    dailyBudgetName: 'default',
  };
  constructor() {
    super();
    uniqueId.enableUniqueIds(this);
  }
  state = {
    tVal: [],
    // eslint-disable-next-line react/no-unused-state
    currentPlatform: '',
  }
  componentDidMount() {
    const { name, registerField } = this.props;
    registerField({ name, validator: this.standardValidator });
  }
  getValueByPlatform = (platform) => {
    const platformIndex = this.state.tVal.findIndex((obj => obj.platform === platform));
    if (this.state.tVal[platformIndex] === undefined) {
      return 0;
    }
    return this.state.tVal[platformIndex].value;
  }
  changeHandler = (e) => {
    e.preventDefault();
    const currentValue = [...this.props.value];
    const {
      target: { value },
    } = e;
    const valueIndex = currentValue.indexOf(value);
    if (valueIndex > -1) {
      currentValue.splice(valueIndex, 1);
    } else {
      currentValue.push(value);
    }
    const { name, changeHandler } = this.props;
    changeHandler({ value: currentValue, name });
  };
  changeHandlerPlatform = (platform) => {
    const { cpiCurrentPlatform } = this.props;
    this.setState({
      // eslint-disable-next-line react/no-unused-state
      currentPlatform: platform,
    });
    cpiCurrentPlatform(platform);
  };
  standardValidator = (value) => {
    const { isRequired } = this.props;

    let valid = true;
    let errorText = '';

    if (isRequired && !(value && value.length)) {
      valid = false;
      errorText = TEXT_FIELD_IS_REQUIRED;
    }
    const status = valid ? TEXT_FIELD_STATUS.VALID : TEXT_FIELD_STATUS.INVALID;

    return { status, errorText };
  };
  renderValuePlatforms = (checkboxValue) => {
    const { cpiFieldState } = this.props;
    // eslint-disable-next-line max-len
    const platformIndex = cpiFieldState.findIndex((obj => obj.platform === checkboxValue));
    return cpiFieldState[platformIndex] && cpiFieldState[platformIndex].value;
  }
  renderValueDailyBudgetPlatforms = (checkboxValue) => {
    const { dailyBudgetState } = this.props;
    // eslint-disable-next-line max-len
    const platformIndex = dailyBudgetState.findIndex((obj => obj.platform === checkboxValue));
    return dailyBudgetState[platformIndex] && dailyBudgetState[platformIndex].value;
  }
  renderStatusPlatforms = (checkboxValue) => {
    const { cpiFieldState } = this.props;
    // eslint-disable-next-line max-len
    const platformIndex = cpiFieldState.findIndex((obj => obj.platform === checkboxValue));
    return cpiFieldState[platformIndex] && cpiFieldState[platformIndex].isDisabled;
  }
  renderCheckbox = (child, checkboxValue, value, disabledValues) => {
    const { nonClickable } = this.props;
    const currentId = this.nextUniqueId();
    const checked = value.indexOf(checkboxValue) > -1;
    const disabled = disabledValues.indexOf(checkboxValue) > -1;
    const { isAdmin } = this.props;
    const noneTextClasses = ['platform-description', 'platform-description-none-text'];
    const platformNoneTextFieldStatus = nonClickable[checkboxValue] &&
      nonClickable[checkboxValue].props.className;
    const checkboxClasses = classNames({
      'checkbox-label': true,
      'checked-checkbox-label': checked,
    });
    const checkboxWrapperClasses = classNames({
      'checkbox-wrapper': true,
      'checked-checkbox-wrapper': platformNoneTextFieldStatus === noneTextClasses[0] && checked,
      'checked-checkbox-wrapper-none-text': platformNoneTextFieldStatus === noneTextClasses[1] && checked,
      'disabled-checkbox': disabled,
    });
    return (
      <div key={currentId} className={checkboxWrapperClasses}>
        <label className={checkboxClasses} htmlFor={currentId}>
          <div className="custom-checkbox-wrapper">
            <div className="checkbox-border">
              <div className="checkbox-inner">
                <svg
                  className="checkmark"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 36 36"
                >
                  <path
                    className="checkmark-check"
                    fill="none"
                    d="M4.1 17.2l7.1 8.5 16.7-16.8"
                  />
                </svg>
              </div>
            </div>
            <input
              disabled={disabled}
              id={currentId}
              checked={checked}
              value={checkboxValue}
              onClick={this.changeHandler}
              type="checkbox"
            />
          </div>

          <div className="checkbox-content">{child}</div>
        </label>
        {this.props.nonClickable[checkboxValue] && (
          <div className="non-clickable-content">
            {this.props.nonClickable[checkboxValue]}
            <div className="cpi-wrapper">
              <div
                className="cpi-field-wrapper"
                onChange={() => this.changeHandlerPlatform(checkboxValue)}
                onMouseEnter={() => {
                  this.props.cpiCurrentPlatform(checkboxValue);
                }}
              >
                <CurrencyFieldPlatforms
                  name={this.props.dailyBudgetName}
                  value={this.renderValueDailyBudgetPlatforms(checkboxValue)}
                  minValue={DAILY_BUDGET_VALUES.MIN}
                  maxValue={10000}
                  platform={checkboxValue}
                  label="Daily Budget"
                  placeholder="Daily Budget"
                  isRequired
                  contextProvider={CONTEXT_PROVIDERS.CreateCampaignFormContext}
                />
              </div>
              <div
                className="cpi-field-wrapper"
                onChange={() => this.changeHandlerPlatform(checkboxValue)}
                onMouseEnter={() => {
                  this.props.cpiCurrentPlatform(checkboxValue);
                }}
              >
                <CurrencyFieldPlatforms
                  name={this.props.cpiFieldName}
                  value={this.renderValuePlatforms(checkboxValue)}
                  maxValue={10000}
                  platform={checkboxValue}
                  label="CPI"
                  placeholder="CPI"
                  disabled={
                    this.renderStatusPlatforms(checkboxValue).length !== 0
                  }
                  isRequired
                  minValue={CPI_VALUES.MIN}
                  contextProvider={CONTEXT_PROVIDERS.CreateCampaignFormContext}
                />
              </div>
              {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
              <div
                className="cpi-field-checkbox"
                onChange={() => this.props.cpiCurrentPlatform(checkboxValue)}
                onMouseEnter={() => {
                  this.props.cpiCurrentPlatform(checkboxValue);
                }}
              >
                <CheckBoxGroup
                  name="cpi"
                  value={this.renderStatusPlatforms(checkboxValue)}
                  values={['auto']}
                  disabled={isAdmin ? [] : []}
                  registerField={this.props.registerField}
                  changeHandler={this.props.changeHandler}
                >
                  <span>Auto</span>
                </CheckBoxGroup>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  render() {
    const {
      children,
      values,
      value,
      header,
      status,
      errorText,
      disabled,
    } = this.props;
    const checkboxButtonClasses = classNames({
      'checkbox-group-wrapper': true,
      'checkbox-group-failed': status === TEXT_FIELD_STATUS.INVALID,
    });
    return (
      <div className={checkboxButtonClasses}>
        {header && (
          <div className="check-group-header">
            <span>{header}</span>
          </div>
        )}
        <div className="checkbox-group">
          {React.Children.map(children, (child, i) =>
            this.renderCheckbox(child, values[i], value, disabled))}
        </div>
        <div className="checkbox-group-error-text">
          <span>{errorText}</span>
        </div>
      </div>
    );
  }
}

export default CheckBoxGroup;



// WEBPACK FOOTER //
// ./src/components/_molecules/CheckBoxGroup/CheckBoxGroup.js